import { OpenAccountUser } from "@/types/openAccount";
import {
  ConfirmationValidationProps,
  Validation,
  ValidationProps,
} from "@/types/validation";

const answerValidation: ValidationProps = {
  regex: /^(?! ).{2,30}(?<! )$/,
  message:
    "Answer must consist of 2-30 characters and cannot start or end with a space",
};

const answerConfirmationValidation: ConfirmationValidationProps = {
  confirmation: (value: string, confirmValue: string) => value === confirmValue,
  regex: /^(?! ).{2,30}(?<! )$/,
  message: "Answers do not match",
};

const pinValidation: ValidationProps = {
  regex: /^\d{6}$/,
  message: "Pin must consist of 6 numbers",
};

const pinConfirmationValidation: ConfirmationValidationProps = {
  confirmation: (value: string, confirmValue: string) => value === confirmValue,
  regex: /^\d{6}$/,
  message: "Pins do not match",
};

const questionIdValidation: ValidationProps = {
  regex: /^\d{1,3}$/,
  message: "Invalid Question",
};

const questionLabelValidation: ValidationProps = {
  regex: /\S/,
  message: "Invalid Question",
};

export const securitySettingsPinValidation: Validation<
  Pick<OpenAccountUser, "pin" | "pinConfirmation">
> = {
  pin: [pinValidation],
  pinConfirmation: [pinConfirmationValidation],
};

export const securitySettingsQuestionValidation: Validation<
  Pick<
    OpenAccountUser["securityQuestion"],
    "answer" | "answerConfirmation" | "id" | "label"
  >
> = {
  answer: [answerValidation],
  answerConfirmation: [answerConfirmationValidation],
  id: [questionIdValidation],
  label: [questionLabelValidation],
};
